import { v4 as uuidv4 } from 'uuid';
import ControlKind from '../Shared/controlKind';
import ControlState from '../Shared/controlState';
import controlConfig from '../Controls/controlDictionary';

export const DragTypes = {
  CARD_CONTROL: 'CardControl',
  PALETTE_CONTROL: 'PaletteControl',
  PAGE_LIST_ITEM: 'PageListItem'
};

export interface DraggableItem {
  id: string;
  originalIndex?: number;
  pageId?: string;
  type?: ControlKind;
}

export const generateSchema = (
  pageId: string,
  type: ControlKind,
  order: number
) => {
  const controlId = `control-${uuidv4()}`;

  const controlSchema = controlConfig[type].getLatestSchema(
    controlId,
    pageId,
    order
  );

  return {
    id: controlId,
    building: true,
    pageId: pageId,
    schema: controlSchema,
    kind: type
  } as ControlState;
};
